<template>
	<div class="thumbnail">
		<img
			:src="getThumbnailSrc()"
			@click="show_origin = true"
			:style="{
				maxHeight: imgMaxHeight,
			}"
		/>

		<v-dialog v-model="show_origin" width="auto">
			<img
				:src="src"
				@click="show_origin = false"
				style="width: auto; max-height: 85vh"
			/>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Thumbnail',
		props: {
			src: String,
			width: Number,
			height: Number,
			imgMaxHeight: {
				type: String,
				default: null,
			},
		},

		data() {
			return {
				show_origin: false,
			};
		},

		methods: {
			getThumbnailSrc() {
				if (this.height) {
					return this.src + '?h=' + this.height;
				} else {
					return this.src + '?w=' + (this.width || 100);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.thumbnail {
		IMG {
			border: 1px solid $btn-blue;
			border-radius: 0.5em;
			cursor: pointer;
			vertical-align: middle;
		}
	}
</style>
